var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupporto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-setting-2209598",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4742",
    "data-name": "Raggruppa 4742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9609",
    "data-name": "Tracciato 9609",
    d: "M12.484,0l.685,2.817a9.706,9.706,0,0,1,2.055.837l2.436-1.522a11.3,11.3,0,0,1,2.131,2.131L18.346,6.775a15.446,15.446,0,0,1,.837,1.979L22,9.516v2.969l-2.817.685a16.562,16.562,0,0,1-.837,2.055l1.446,2.436a9.439,9.439,0,0,1-2.131,2.131l-2.436-1.446a16.562,16.562,0,0,1-2.055.837L12.484,22H9.516l-.761-2.817a15.446,15.446,0,0,1-1.979-.837L4.263,19.792a11.3,11.3,0,0,1-2.131-2.131l1.522-2.436a9.706,9.706,0,0,1-.837-2.055L0,12.484V9.516l2.817-.761a9.094,9.094,0,0,1,.837-1.979L2.131,4.263A14.107,14.107,0,0,1,4.263,2.131L6.775,3.654a9.094,9.094,0,0,1,1.979-.837L9.516,0ZM10.962,5.481a5.5,5.5,0,1,1-4.035,9.211A5.521,5.521,0,0,1,10.962,5.481Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporto);
export default __webpack_public_path__ + "static/media/Supporto.5346c7c4bfbdc03754d4774867070be4.svg";
export { ForwardRef as ReactComponent };